import { webKnots } from '../../../common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { verticalPartOfVWeb2 } from './parts/verticalParts'
import { lacePartsOfWeb1, lacePartsOfWeb2 } from './parts/laceParts'

export const vWebWithLace = (ctx: CanvasRenderingContext2D, webColor: string, web2Color: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor

  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfVWeb2(ctx, web2Color, laceColor, stitchColor)
  // lace
  halfLace(ctx, laceColor)
  // 捕球面上のウェブ結び目
  crossLace(ctx, laceColor, 0, 0)
  crossLace(ctx, laceColor, -20, 25)
  crossLace(ctx, laceColor, -45, 65)
  webKnots(ctx, laceColor, -90, 90)
  webKnots(ctx, laceColor, -130, 130)
}

const halfLace = (ctx: CanvasRenderingContext2D, laceColor: string): void => {
  // 左
  lacePartsOfWeb1(ctx, laceColor, 54, 170, 1, 0.8) //
  lacePartsOfWeb1(ctx, laceColor, 45, 194, 1, 0.8) //
  lacePartsOfWeb1(ctx, laceColor, 36, 218, 1, 0.8) //

  // // 右
  lacePartsOfWeb2(ctx, laceColor, 130, 25, 10, 0.8)
  lacePartsOfWeb2(ctx, laceColor, 118, 45, 10, 0.8)
  lacePartsOfWeb2(ctx, laceColor, 105, 65, 10, 0.8)
}

const crossLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  // 左上-右下方向
  ctx.beginPath()
  ctx.moveTo(552 + x, 248 + y) // 左上＿下
  ctx.quadraticCurveTo(563 + x, 263 + y, 559 + x, 289 + y) // 右下＿左
  ctx.quadraticCurveTo(562 + x, 293 + y, 567 + x, 289 + y) // 右下＿右
  ctx.quadraticCurveTo(575 + x, 257 + y, 557 + x, 240 + y) // 左上＿上
  ctx.quadraticCurveTo(554 + x, 234 + y, 552 + x, 248 + y) // 左上＿下
  ctx.fill()
  ctx.moveTo(553 + x, 244 + y) // 左上＿下
  ctx.quadraticCurveTo(567 + x, 260 + y, 562 + x, 290 + y) // 右下＿左
  ctx.stroke()
  ctx.closePath()
  // 左下-右上方向
  ctx.beginPath()
  ctx.moveTo(545 + x, 259 + y) // 左下＿上
  ctx.quadraticCurveTo(540 + x, 262 + y, 537 + x, 267 + y) // 左下＿下
  ctx.quadraticCurveTo(560 + x, 268 + y, 578 + x, 275 + y) // 右上＿下
  ctx.quadraticCurveTo(584 + x, 273 + y, 583 + x, 269 + y) // 右上＿上
  ctx.quadraticCurveTo(566 + x, 256 + y, 545 + x, 259 + y) // 左下＿上
  ctx.fill()
  ctx.moveTo(538 + x, 265 + y) // 左下
  ctx.quadraticCurveTo(560 + x, 263 + y, 578 + x, 274 + y) // 右上
  ctx.stroke()
  ctx.closePath()
}
